import { render, staticRenderFns } from "./facenatpay.vue?vue&type=template&id=7fbeef62&scoped=true"
import script from "./facenatpay.vue?vue&type=script&lang=js"
export * from "./facenatpay.vue?vue&type=script&lang=js"
import style0 from "./facenatpay.vue?vue&type=style&index=0&id=7fbeef62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbeef62",
  null
  
)

export default component.exports